import notificationAr from './ar.json'

const messages = {
  ar: {
    ...notificationAr,
  },
}

export default messages
